
// Find out what cookies are supported. Returns:
// null - no cookies
// false - only session cookies are allowed
// true - session cookies and persistent cookies are allowed
// (though the persistent cookies might not actually be persistent, if the user has set
// them to expire on browser exit)
//
function getCookieSupport() {
    var persist= true;
    do {
        var c= 'gCStest='+Math.floor(Math.random()*100000000);
        document.cookie= persist? c+';expires=Tue, 01-Jan-2030 00:00:00 GMT' : c;
        if (document.cookie.indexOf(c)!==-1) {
            document.cookie= c+';expires=Sat, 01-Jan-2000 00:00:00 GMT';
            return persist;
        }
    } while (!(persist= !persist));
    return null;
}

function reloadPageIfNecessary(preference) {
  if (preference == 'none') {
    return;
  } else {
    var current = $(location).attr("href");
    if (current.match('#' + preference) || current.match('/' + preference + '/')) {
    } else {
      if (current.match('#arena') || current.match('#paper') || current.match('#online') ) {
        window.location = "#" + preference;
      } else if (current.match('/online/')) {
        window.location = current.replace('/online/', '/' + preference + '/');
      } else if (current.match('/paper/')) {
        window.location = current.replace('/paper/', '/' + preference + '/');
      } else if (current.match('/arena/')) {
        window.location = current.replace('/arena/', '/' + preference + '/');
      }
    }
  }
}

$(function(){
  // check cookie
  var preference = Cookies.get('type-preference');

  if (preference == 'online') {
    $("#default_type_switcher_online").prop("checked", true);
  } else if (preference == 'arena') {
    $("#default_type_switcher_arena").prop("checked", true);
  } else {
    $("#default_type_switcher_paper").prop("checked", true);
  }

  $('#default-toggle-online').click(function(){
   Cookies.set('type-preference', 'online', { expires: 3650, path: '/' });
   reloadPageIfNecessary('online');
  });

  $('#default-toggle-paper').click(function(){
   Cookies.set('type-preference', 'paper', { expires: 3650, path: '/' });
   reloadPageIfNecessary('paper');
  });

  $('#default-toggle-arena').click(function(){
   Cookies.set('type-preference', 'arena', { expires: 3650, path: '/' });
   reloadPageIfNecessary('arena');
  });
});
